import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectVirtualCard,
  selectVirtualCardIdFromRoute,
} from 'src/app/UpdateVirtualCardForm/redux/updateVirtualCardForm.selectors'
import UpdateVirtualCardForm from 'src/app/UpdateVirtualCardForm/UpdateVirtualCardForm'
import { UpdateVirtualCardScreen } from 'src/app/UpdateVirtualCardForm/UpdateVirtualCardScreen'
import RightFlyout, {
  RightFlyoutBodyWidths,
} from 'src/components/RightFlyout/RightFlyout'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { updateVirtualCardUrl } from 'src/navigation/urls'
import {
  getVirtualCard,
  getVirtualCardPermissions,
} from 'src/redux/actions/data/virtualCards.actions'

const UpdateBillPay: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const virtualCard = useSelector(selectVirtualCard)
  const [loadingFlyout, setLoadingFlyout] = useState(true)

  useEffect((): void => {
    if (virtualCardId) {
      setLoadingFlyout(true)
      dispatch(getVirtualCard(virtualCardId))
      dispatch(getVirtualCardPermissions(virtualCardId))
    }
  }, [virtualCard?.status, virtualCardId])

  useEffect(() => {
    if (virtualCard === undefined) return

    if (virtualCard.isBillPay) {
      setLoadingFlyout(false)
    } else {
      // user is trying to access a regular virtual card, redirect to the virtual card url
      dispatch(connectedReplace(updateVirtualCardUrl(virtualCardId)))
    }
  }, [virtualCard])

  return (
    <RightFlyout width={RightFlyoutBodyWidths.Action}>
      <UpdateVirtualCardForm
        screen={UpdateVirtualCardScreen.BillPay}
        virtualCardId={virtualCardId}
        virtualCard={virtualCard}
        loadingFlyout={loadingFlyout}
      />
    </RightFlyout>
  )
}

export default UpdateBillPay
